import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import {
  Divider,
  Grid,
  Header,
  Input,
  Segment,
  Table,
  Dropdown
} from 'semantic-ui-react';
import { servicesAPI } from '../../_services';
import { getLocalStorage, dbUTCDatetimeToLocal } from '../../utils';
import { history } from '../../_helpers';
import { useUsers } from '../../_services';

const activityOptions = [
  { text: 'SupportOperation', value: 'SupportOperation' },
  { text: 'BillingPayment', value: 'BillingPayment' },
  { text: 'CustomerDeactivate', value: 'CustomerDeactivate' },
  { text: 'BillingRefund', value: 'BillingRefund' },
  { text: 'LanceRemoval', value: 'LanceRemoval' },
  { text: 'CustomerEmail', value: 'CustomerEmail' },
  { text: 'LanceAssignment', value: 'LanceAssignment' },
  { text: 'CustomerContractSign', value: 'CustomerContractSign' }
];

const countOptions = [
  { text: '50', value: 50 },
  { text: '100', value: 100 },
  { text: '250', value: 250 },
  { text: '500', value: 500 },
  { text: '1000', value: 1000 }
];

export const ListAudit = () => {
  const users = useUsers();

  const [audits, setAudits] = useState([]);
  const [numAudits, setNumAudits] = useState(50);
  const [notesFilter, setNotesFilter] = useState('');
  const [activityFilter, setActivityFilter] = useState(['ACTIVE']);
  const [sortColumn, setSortColumn] = useState(null);
  const [sortDirection, setSortDirection] = useState('desc');
  const [sortLabel, setSortLabel] = useState('descending');
  const [sortedData, setSortedData] = useState([]);

  const sortTable = column => {
    setSortColumn(column);
    setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    setSortLabel(sortLabel === 'ascending' ? 'descending' : 'ascending');

    localStorage.setItem('adminAuditsSrtColumn', column);
    localStorage.setItem(
      'adminAuditsSrtDir',
      sortDirection === 'asc' ? 'desc' : 'asc'
    );
  };

  useEffect(() => {
    // Use user's preferred filter/sort settings otherwise defaults
    setNumAudits(parseInt(getLocalStorage('adminAuditsNumEvnts', 50)));
    setNotesFilter(getLocalStorage('adminAuditsFltrDesc', ''));
    setActivityFilter(
      JSON.parse(getLocalStorage('adminAuditsFltrActivity', '[]'))
    );

    sortTable(getLocalStorage('adminAuditsSrtColumn', 'id'));
    const dir = getLocalStorage('adminAuditsSrtDir', 'desc');
    setSortDirection(dir);
    setSortLabel(dir === 'asc' ? 'descending' : 'ascending');
  }, []);

  useEffect(() => {
    if (!users.length) return;

    servicesAPI
      .AdminServices('getUserActivitiesByType', 0, 'ALL', numAudits)
      .then(audits => {
        setAudits(
          audits.map(audit => ({
            ...audit,
            user: users.find(u => u.id === audit.user_id)
          }))
        );
      });
  }, [numAudits, users]);

  useEffect(() => {
    if (audits.length === 0) return;

    const sorted =
      sortColumn && sortDirection
        ? _.orderBy(audits, sortColumn, sortDirection)
        : audits;

    setSortedData(
      sorted
        .filter(
          ({ notes }) =>
            !notesFilter ||
            notes.toLowerCase().includes(notesFilter.toLowerCase())
        )
        .filter(
          ({ activity }) =>
            !activityFilter.length || activityFilter.includes(activity)
        )
    );
  }, [audits, notesFilter, activityFilter, sortColumn, sortDirection]);

  return (
    <Segment>
      <Grid stretched>
        <Grid.Row>
          <Grid.Column>
            <Header as="h2">Audit Events</Header>
          </Grid.Column>
        </Grid.Row>
        <Grid>
          <Grid.Column>
            <Grid.Row>
              <Header as="h4">Show no. actions</Header>
              <Dropdown
                selection
                options={countOptions}
                onChange={(_, { value }) => {
                  setNumAudits(value);
                  localStorage.setItem('adminAuditsNumEvnts', value);
                }}
                value={numAudits}
              />
            </Grid.Row>
          </Grid.Column>
        </Grid>
        <Grid.Row>
          <Grid.Column mobile={8} tablet={6} computer={4}>
            <Dropdown
              placeholder="filter action types"
              selection
              search
              options={activityOptions}
              multiple
              onChange={(e, { value }) => {
                setActivityFilter(value);
                localStorage.setItem(
                  'adminAuditsFltrActivity',
                  JSON.stringify(value)
                );
              }}
              value={activityFilter}
            />
          </Grid.Column>
          <Grid.Column mobile={8} tablet={6} computer={4}>
            <Input
              type="text"
              placeholder="filter action description"
              icon={{
                name: 'close',
                link: true,
                onClick: () => {
                  setNotesFilter('');
                  localStorage.setItem('adminAuditsFltrDesc', '');
                }
              }}
              value={notesFilter}
              onChange={(event, { value }) => {
                setNotesFilter(value);
                localStorage.setItem('adminAuditsFltrDesc', value);
              }}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
      <Divider hidden />
      <Grid>
        <Table sortable celled>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell
                sorted={sortColumn === 'timestamp' ? sortLabel : null}
                onClick={() => sortTable('timestamp')}
              >
                Date / Time
              </Table.HeaderCell>
              <Table.HeaderCell>User</Table.HeaderCell>
              <Table.HeaderCell
                sorted={sortColumn === 'activity' ? sortLabel : null}
                onClick={() => sortTable('activity')}
              >
                Action Type
              </Table.HeaderCell>
              <Table.HeaderCell
                sorted={sortColumn === 'notes' ? sortLabel : null}
                onClick={() => sortTable('notes')}
              >
                Action Description
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {sortedData.map((d, idx) => (
              <Table.Row
                key={idx}
                onClick={() => {
                  if (d.entity_type === 'PHALANX') {
                    const bits = d.entity_id.split('_cs');
                    const hubRef = bits[0];
                    const csId = 'cs' + bits[1];

                    history.push(`/admin/hubs/${hubRef}/${csId}`);
                  } else if (d.entity_type === 'CUSTOMER') {
                    history.push(`/admin/customer/${d.entity_id}`);
                  }
                }}
              >
                <Table.Cell>{dbUTCDatetimeToLocal(d.timestamp)}</Table.Cell>
                <Table.Cell>
                  {d.user?.user_name}{' '}
                  {d.user?.roles.includes('Customer') ? ' (customer)' : ''}
                </Table.Cell>
                <Table.Cell>{d.activity}</Table.Cell>
                <Table.Cell>{d.notes}</Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      </Grid>
    </Segment>
  );
};
